import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/download/69a9486c4fab3d0014350dd9/foundation1899/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69a9486c4fab3d0014350dd9/foundation1899/src/app/homepage/components/StoreHub.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69a9486c4fab3d0014350dd9/foundation1899/src/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69a9486c4fab3d0014350dd9/foundation1899/src/components/ui/AppLogo.tsx");
